var _a;
import * as Languages from './Language';
export var EN = 'en';
export var RU = 'ru';
export var UZ = 'uz';
export var KK = 'kk';
var localeMap = (_a = {},
    _a[Languages.RU] = 'ru',
    _a[Languages.EN] = 'en',
    _a[Languages.UZ] = 'uz',
    _a[Languages.KK] = 'kk',
    _a);
export default localeMap;



// WEBPACK FOOTER //
// ./src/constants/Locale.js